module.exports = __webpack_public_path__ + "static/media/Acer_gif_tv.1fadc7db.gif";